import { eaFetch } from '../common/ApiUtils';
import { getEnv } from '../../config/Config';

export async function getContextModel(accountId, dispatch) {
  const models = await eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'GET',
    `365/accounts/${accountId}/context-model`
  );
  dispatch({ type: 'SET_CONTEXT_MODELS', payload: models });
  return models;
}

export async function saveContextModel(accountId, body, dispatch) {
  return eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'POST',
    `365/accounts/${accountId}/context-model`,
    body
  );
}

export async function updateContextModel(
  accountId,
  contextModelId,
  body,
  dispatch
) {
  return eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'PUT',
    `365/accounts/${accountId}/context-model/${contextModelId}`,
    body
  );
}

export async function saveContextModelAttribute(accountId, body, dispatch) {
  return eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'POST',
    `365/accounts/${accountId}/context-model/attribute`,
    body
  );
}

export async function saveContextInstance(accountId, body, dispatch) {
  return eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'POST',
    `365/accounts/${accountId}/context-instance`,
    body
  );
}

export async function updateContextInstance(
  accountId,
  contextInstanceid,
  body,
  dispatch
) {
  return eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'PUT',
    `365/accounts/${accountId}/context-instances/${contextInstanceid}`,
    body
  );
}

export async function updateContextInstanceAttributeValue(
  accountId,
  instanceId,
  body,
  dispatch
) {
  return eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'POST',
    `365/accounts/${accountId}/context-instance/${instanceId}/update-attribute-value`,
    body
  );
}

export async function updateContextInstanceThirdPartyAttributeValue(
  accountId,
  instanceId,
  thirdpartyId,
  body,
  dispatch
) {
  return eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'POST',
    `365/accounts/${accountId}/context-instance/${instanceId}/thirdparty/${thirdpartyId}/update-attribute-value`,
    body
  );
}

export async function saveContextInstanceThirdparty(accountId, body, dispatch) {
  return eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'POST',
    `365/accounts/${accountId}/context-instance/thirdparty`,
    body
  );
}

export async function getContextInstances(
  accountId,
  active = true,
  dispatch,
  limit = 10000,
  offset = 0
) {
  const instances = await eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'GET',
    `365/accounts/${accountId}/context-instances?active=${active}&limit=${limit}&offset=${offset}`
  );
  dispatch({ type: 'SET_CONTEXT_INSTANCES', payload: instances });
  return instances;
}

export async function getFilteredContextInstances(
  accountId,
  active = true,
  limit = 10000,
  offset = 0,
  body,
  dispatch,
) {
  const instances = await eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'POST',
    `365/accounts/${accountId}/context-instances?active=${active}&limit=${limit}&offset=${offset}`,
    body
  );
  dispatch({ type: 'SET_CONTEXT_INSTANCES', payload: instances });
  return instances;
}

export async function getContextInstance(accountId, instanceId, dispatch) {
  return eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'GET',
    `365/accounts/${accountId}/context-instance/${instanceId}`
  );
}

export async function getContextInstanceThirdParty(
  accountId,
  instanceId,
  dispatch
) {
  const contextThirdParties = await eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'GET',
    `365/accounts/${accountId}/context-instance/${instanceId}/thirdparties`
  );
  dispatch({ type: 'SET_CONTEXT_THIRDPARTIES', payload: contextThirdParties });
  return contextThirdParties;
}

export async function getContextInstanceThirdPartyXls(
  accountId,
  instanceId,
  dispatch
) {
  const byteArrayOutputStream = await eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'GET',
    `365/accounts/${accountId}/context-instance/${instanceId}/thirdparties/download`,
    null,
    null,
    true
  );
  return byteArrayOutputStream;
}

export async function getContextInstanceThirdPartyAttributes(
  accountId,
  tpId,
  instanceId,
  dispatch
) {
  const contextThirdPartyAttributes = await eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'GET',
    `365/accounts/${accountId}/context-thirdparty/${tpId}/${instanceId}`
  );
  return contextThirdPartyAttributes;
}

export async function getContextThirdpartyByTPid(accountId, tpId, dispatch) {
  return eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'GET',
    `365/accounts/${accountId}/context-thirdparties/${tpId}`
  );
}

export async function getAccountAttributeById(
  accountId,
  attributeId,
  dispatch
) {
  return eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'GET',
    `365/accounts/${accountId}/attribute/${attributeId}`
  );
}

export async function saveContextModelStatus(accountId, body, dispatch) {
  return eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'POST',
    `365/accounts/${accountId}/context-model/status`,
    body
  );
}

export async function deleteContextModel(accountId, contextModelId, dispatch) {
  return eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'DELETE',
    `365/accounts/${accountId}/context-model/delete/${contextModelId}`
  );
}

export async function archiveContextInstance(
  accountId,
  contextInstanceId,
  body,
  dispatch
) {
  return eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'POST',
    `365/accounts/${accountId}/context-instance/archive/${contextInstanceId}`,
    body
  );
}

export async function reactivateContextInstance(
  accountId,
  contextInstanceId,
  dispatch
) {
  return eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'POST',
    `365/accounts/${accountId}/context-instance/reactivate/${contextInstanceId}`
  );
}

export async function archiveThirdParty(accountId, tpId, body, dispatch) {
  return eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'POST',
    `365/accounts/${accountId}/thirdparty/archive/${tpId}`,
    body
  );
}

export async function reactivateThirdParty(accountId, tpId, dispatch) {
  return eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'POST',
    `365/accounts/${accountId}/thirdparty/reactivate/${tpId}`
  );
}

export async function deleteThirdParty(accountId, tpId, dispatch) {
  return eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'DELETE',
    `365/accounts/${accountId}/thirdparty/delete/${tpId}`
  );
}

export async function createThirdPartyDossier(
  accountId,
  thirdpartyId,
  contextThirdpartyId,
  body,
  dispatch
) {
  return eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'POST',
    `365/accounts/${accountId}/thirdparty/${thirdpartyId}/${contextThirdpartyId}/create-dossier`,
    body
  );
}

export async function getCalculationResult(accountId, thirdpartyId, dispatch) {
  return eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'GET',
    `365/accounts/${accountId}/calculation-result/${thirdpartyId}`
  );
}

export async function isContextModelNameAvailable(accountId, name, dispatch) {
  return eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'GET',
    `365/accounts/${accountId}/is-context-model-name-available?name=${name}`
  );
}

export async function isContextInstanceNameAvailable(
  accountId,
  name,
  modelId,
  dispatch
) {
  return eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'GET',
    `365/accounts/${accountId}/is-context-instance-name-available?name=${name}&modelId=${modelId}`
  );
}
